import { getBenchInstanceClient } from "@/lib/clients";
import { queryClient } from "@/lib/query-client";
import { useQuery } from "@tanstack/react-query";
import { BenchStateFull } from "@myth-finance/bench-sdk";

const queryKeyPrefix = "bench-1";

export const useBenchState = (
  appId: bigint | undefined,
  registryAppId: bigint,
  account?: string
) => {
  return useQuery({
    queryKey: [queryKeyPrefix, String(appId), account ?? "anon"],
    staleTime: 60 * 1_000,
    enabled: !!appId,
    queryFn: async (): Promise<BenchStateFull> => {
      if (!appId) return {} as BenchStateFull;
      console.log("Fetching bench ID", appId);
      const state = await getBenchInstanceClient(
        appId,
        registryAppId
      ).getFullState(account);
      return state;
    },
  });
};

export const clearBenchCache = (benchId?: bigint) => {
  const queryKey = [queryKeyPrefix];
  if (benchId) queryKey.push(String(benchId));
  queryClient.invalidateQueries({ queryKey });
};
